<template>
  <div id="message-dialog">
    <v-dialog v-model="messageDialog" width="600">
      <v-card>
        <v-card-title>{{ dialogText.title }}</v-card-title>
        <v-card-text class="text-lg-body-1">{{
          dialogText.message
        }}</v-card-text>
        <v-card-actions class="px-5 pb-5">
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="messageDialog = false" width="100"
            >確認</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, PropSync } from "vue-property-decorator";

@Component
export default class MessageDialog extends Vue {
  /** ダイアログ表示フラグ */
  @PropSync("messageDialogFlag", { type: Boolean, default: false })
  messageDialog!: boolean;

  /** ダイアログテキスト */
  @Prop({ type: Object })
  dialogText!: {
    title: string;
    message: string;
  };
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
</style>
